import { Container } from '@pixi/display';
import { Sprite } from 'pixi.js';

export abstract class Widget
{
    protected _view: Container;
    protected _opened = false;
    protected _built = false;
    protected base?: Sprite;

    constructor()
    {
        this._view = new Container();
        this._view.visible = false;
    }

    public get view(): Container
    {
        return this._view;
    }

    public async open(): Promise<void>
    {
        if (this._opened) return;
        if (!this._built) await this.build();
        this._built = true;
        this._opened = true;
        this._view.visible = true;
        this._view.updateTransform();
        await this.onOpen();
    }

    public async close(): Promise<void>
    {
        if (!this._opened) return;
        this._opened = false;
        await this.onClose();
        this._view.visible = false;
    }

    protected async build(): Promise<void>
    {
        // For subclasses
    }

    protected async onOpen(): Promise<void>
    {
        // For subclasses
    }

    protected async onClose(): Promise<void>
    {
        // For subclasses
    }

    public get left(): number
    {
        if (!this.base) return 0;

        return this.view.x - (this.base.width * this.base.anchor.x);
    }

    public set left(v: number)
    {
        if (!this.base) return;
        this.view.x = v + (this.base.width * this.base.anchor.x);
    }

    public get top(): number
    {
        if (!this.base) return 0;

        return this.view.y - (this.base.height * this.base.anchor.y);
    }

    public set top(v: number)
    {
        if (!this.base) return;
        this.view.y = v + (this.base.height * this.base.anchor.y);
    }

    public get right(): number
    {
        if (!this.base) return 0;

        return this.view.x + (this.base.width * this.base.anchor.x);
    }

    public set right(v: number)
    {
        if (!this.base) return;
        this.view.x = v - (this.base.width * this.base.anchor.x);
    }

    public get bottom(): number
    {
        if (!this.base) return 0;

        return this.view.y + (this.base.height * this.base.anchor.y);
    }

    public set bottom(v: number)
    {
        if (!this.base) return;
        this.view.y = v - (this.base.height * this.base.anchor.y);
    }

    public get centerX(): number
    {
        return this.view.x;
    }

    public set centerX(v: number)
    {
        this.view.x = v;
    }

    public get centerY(): number
    {
        return this.view.y;
    }

    public set centerY(v: number)
    {
        this.view.y = v;
    }
}
